import { createContext, useContext } from 'react';

export const ReportContext = createContext(null);

export function useReport() {
  return useContext(ReportContext);
}
